// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.typography--whiteText--UWQvU {
  color: white;
  fill: white;
}

.typography--boldText--WQ4ng {
  font-weight: bold;
}

.typography--lightText--wiuvb {
  font-weight: 300;
}

.typography--smallSize--L9OYM {
  font-size: 12px;
}

.typography--axisSize--r65nL {
  font-size: 14px;
}

.typography--defaultSize--cm0mU {
  font-size: 14px;
}

.typography--largeSize--qZsM0 {
  font-size: 16px;
}

.typography--extraLargeSize--Hn0bJ {
  font-size: 24px;
}

.typography--mediumContrastText--P2Hc4 {
  color: var(--text-medium-contrast);
  fill: var(--text-medium-contrast);
}

.typography--highContrastText--RqzA3 {
  color: var(--text-high-contrast);
  fill: var(--text-high-contrast);
}

.typography--noWrap--SAkvI {
  white-space: nowrap;
}

.typography--svgMiddleAnchored--gZHNX {
  text-anchor: middle;
}

.typography--svgRightAnchored--qqiLN {
  text-anchor: end;
}

.typography--svgStartAnchored--lCDnf {
  text-anchor: start;
}

.typography--svgVerticalCentered--HT9GL {
  dominant-baseline: central;
}
`, "",{"version":3,"sources":["webpack://./src/styles/typography.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n.whiteText {\n  color: white;\n  fill: white;\n}\n\n.boldText {\n  font-weight: bold;\n}\n\n.lightText {\n  font-weight: 300;\n}\n\n.smallSize {\n  font-size: 12px;\n}\n\n.axisSize {\n  font-size: 14px;\n}\n\n.defaultSize {\n  font-size: 14px;\n}\n\n.largeSize {\n  font-size: 16px;\n}\n\n.extraLargeSize {\n  font-size: 24px;\n}\n\n.mediumContrastText {\n  color: var(--text-medium-contrast);\n  fill: var(--text-medium-contrast);\n}\n\n.highContrastText {\n  color: var(--text-high-contrast);\n  fill: var(--text-high-contrast);\n}\n\n.noWrap {\n  white-space: nowrap;\n}\n\n.svgMiddleAnchored {\n  text-anchor: middle;\n}\n\n.svgRightAnchored {\n  text-anchor: end;\n}\n\n.svgStartAnchored {\n  text-anchor: start;\n}\n\n.svgVerticalCentered {\n  dominant-baseline: central;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"whiteText": `typography--whiteText--UWQvU`,
	"boldText": `typography--boldText--WQ4ng`,
	"lightText": `typography--lightText--wiuvb`,
	"smallSize": `typography--smallSize--L9OYM`,
	"axisSize": `typography--axisSize--r65nL`,
	"defaultSize": `typography--defaultSize--cm0mU`,
	"largeSize": `typography--largeSize--qZsM0`,
	"extraLargeSize": `typography--extraLargeSize--Hn0bJ`,
	"mediumContrastText": `typography--mediumContrastText--P2Hc4`,
	"highContrastText": `typography--highContrastText--RqzA3`,
	"noWrap": `typography--noWrap--SAkvI`,
	"svgMiddleAnchored": `typography--svgMiddleAnchored--gZHNX`,
	"svgRightAnchored": `typography--svgRightAnchored--qqiLN`,
	"svgStartAnchored": `typography--svgStartAnchored--lCDnf`,
	"svgVerticalCentered": `typography--svgVerticalCentered--HT9GL`
};
export default ___CSS_LOADER_EXPORT___;
